import { Link } from 'react-router-dom';
import { CAREER_JOBS } from 'src/features/brightsaas/careers/jobsConfig';

export function CareersPage() {
  return (
    <>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xxl-7 col-lg-8">
                  <div className="position-relative text-center">
                    <div className="fs-9 text-uppercase text-gradient-a w-max mx-auto mb-4">
                      Careers
                    </div>
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      Join the Yapamar Team
                    </h2>
                    <p className="fs-8">
                      We&apos;re building the future of marketing analytics.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8 col-lg-10">
                  {CAREER_JOBS.length === 0 && (
                    <p className="fs-8 text-center text-muted">
                      No open positions right now — check back soon.
                    </p>
                  )}
                  <ul className="nk-list">
                    {CAREER_JOBS.map((job) => (
                      <li
                        key={job.slug}
                        className="card card-bordered bg-background mb-4">
                        <div className="card-body d-flex flex-wrap justify-content-between align-items-center gap-3">
                          <div>
                            <h5 className="title mb-1">{job.title}</h5>
                            <p className="fs-9 text-muted mb-0">
                              {job.location} · {job.employmentType}
                            </p>
                          </div>
                          <Link
                            className="btn btn-primary btn-md"
                            to={`/careers/${job.slug}`}>
                            View &amp; Apply
                          </Link>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
